const section = document.querySelector('.testimonials-parallax_cards')
const cards = section.querySelectorAll('.card-wrapper')

const observeSection = (entries, observer) => {
	entries.forEach(entry => {
		if (entry.isIntersecting) {
			window.addEventListener('scroll', moveCards)
		} else {
			window.removeEventListener('scroll', moveCards)
		}
	})
}

const moveCards = () => {
	let box = section.getBoundingClientRect()
	let middle = (window.innerHeight - box.height) / 2
	let positionConstant = (box.top - middle) * 0.1

	cards.forEach(card => {
		let speed = parseFloat(card.dataset.speed)

		card.setAttribute(
			'style',
			`transform: translateY(${speed * positionConstant}px);`
		)
	})
}

const resetCards = () => {
	cards.forEach(card => {
		card.setAttribute('style', '')
	})
}

const observer = new IntersectionObserver(observeSection)
let observerHandle = null

if (window.innerWidth >= 1200) {
	observerHandle = observer.observe(section)
}

window.addEventListener('resize', () => {
	if (window.innerWidth >= 1200 && !observerHandle) {
		observerHandle = observer.observe(section)
	} else if (window.innerWidth < 1200) {
		observer.unobserve(section)
		observerHandle = null
		window.removeEventListener('scroll', moveCards)
		resetCards()
	}
})
